export default __webpack_public_path__ + "static/media/icon-group-3.1.0861ec8c.png";